import * as types from './types';
import { createReducer } from '../../utils';

export default createReducer({
  screenSizes: [],
})({
  [types.SET_SCREEN_SIZES]: (state, action) => ({ ...state, screenSizes: action.payload }),
});
